import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isExpanded", "ids", "onClick", "styleSheet", "label", "description"];
import React from 'react';
import { compose, setDisplayName, withProps, withStateHandlers } from 'recompose';
import omitProps from '@hocs/omit-props';
import View from '@bubble-ui/primitive-view';
import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';
import { withDesignVersion } from '@bubble-ui/provider-design-version';
import wrapOverridableComponent from '@bubble-ui/hoc-wrap-overridable-component';
import ActionIconChevronBottom from '@bubble-ui/icon-action-chevron-bottom';
import ActionIconChevronTop from '@bubble-ui/icon-action-chevron-top';
import Touchable from '@bubble-ui/primitive-touchable';
import TitleTertiary from '@bubble-ui/molecule-title-information';

var getDefaultStyleSheet = function getDefaultStyleSheet(_ref) {
  var designVersion = _ref.designVersion,
      isLast = _ref.isLast;
  return {
    containerStyle: {
      backgroundColor: 'transparent',
      borderColor: Colors.__borderSubtleInline(designVersion).toString(),
      borderRadius: 0,
      borderStyle: 'solid',
      borderTopWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: isLast ? 1 : 0,
      borderLeftWidth: 0,
      boxSizing: 'border-box',
      position: 'relative',
      width: '100%'
    },
    descriptionStyle: {
      paddingBottom: 20
    },
    touchableStyle: {
      cursor: 'pointer',
      backgroundColor: 'transparent',
      border: 'none',
      outline: 'none'
    },
    headerStyle: {
      paddingLeft: 0,
      paddingRight: 20,
      width: '100%',
      paddingBottom: 15,
      paddingTop: 14,
      position: 'relative'
    },
    rightIconStyle: {
      position: 'absolute',
      right: 0,
      top: 19
    }
  };
};

var getIds = function getIds(_ref2) {
  var id = _ref2.id;
  return {
    ids: id ? {
      root: id,
      text: "".concat(id, "__text"),
      rightIcon: "".concat(id, "__right-icon")
    } : {}
  };
};

var SelectorExpandableOption = function SelectorExpandableOption(_ref3) {
  var isExpanded = _ref3.isExpanded,
      ids = _ref3.ids,
      onClick = _ref3.onClick,
      _ref3$styleSheet = _ref3.styleSheet,
      containerStyle = _ref3$styleSheet.containerStyle,
      descriptionStyle = _ref3$styleSheet.descriptionStyle,
      headerStyle = _ref3$styleSheet.headerStyle,
      rightIconStyle = _ref3$styleSheet.rightIconStyle,
      touchableStyle = _ref3$styleSheet.touchableStyle,
      label = _ref3.label,
      description = _ref3.description,
      props = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/React.createElement(View, _extends({
    id: ids.root,
    style: containerStyle
  }, props), /*#__PURE__*/React.createElement(Touchable, {
    id: ids.text,
    onClick: onClick,
    onPress: onClick,
    style: touchableStyle,
    type: "button"
  }, /*#__PURE__*/React.createElement(View, {
    style: headerStyle
  }, /*#__PURE__*/React.createElement(TitleTertiary, null, label), /*#__PURE__*/React.createElement(View, {
    id: ids.rightIcon,
    style: rightIconStyle
  }, isExpanded ? /*#__PURE__*/React.createElement(ActionIconChevronTop, null) : /*#__PURE__*/React.createElement(ActionIconChevronBottom, null)))), isExpanded && /*#__PURE__*/React.createElement(View, {
    style: descriptionStyle
  }, description));
};

export default compose(setDisplayName('SelectorExpandableOption'), withStateHandlers(function (_ref4) {
  var _ref4$expanded = _ref4.expanded,
      expanded = _ref4$expanded === void 0 ? false : _ref4$expanded;
  return {
    isExpanded: expanded
  };
}, {
  onClick: function onClick(_ref5, _ref6) {
    var isExpanded = _ref5.isExpanded;
    var _onClick = _ref6.onClick;
    return function () {
      var newState = {
        isExpanded: !isExpanded
      };

      _onClick(newState.isExpanded);

      return newState;
    };
  }
}), withDesignVersion, wrapOverridableComponent('SelectorExpandableOption', getDefaultStyleSheet), withProps(getIds), omitProps('id', 'expanded', 'isLast', 'designVersion'))(SelectorExpandableOption);
//# sourceMappingURL=index.js.map